// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import type { TourTotalsByHoleResponse } from './types';

/**
 * The anonymous/guest preview snapshot (BuildPreviewPayloadAsync in the BFF) sends
 * `totalsByHole: {}` — truthy, but without the `series`/`holes`/`rounds` arrays that
 * PositionGraph and ResultsTable dereference unconditionally. Rendering with it threw
 * and tripped the app error boundary for claimed guests. Treat anything that does not
 * carry all three arrays as "no per-hole data yet".
 */
export function normalizeTotalsByHole(value: unknown): TourTotalsByHoleResponse | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return null;
  }

  const raw = value as TourTotalsByHoleResponse;
  if (!Array.isArray(raw.series) || !Array.isArray(raw.holes) || !Array.isArray(raw.rounds)) {
    return null;
  }

  return raw;
}
